import React from 'react';
import { Box } from '@mui/material';

import PhoneIcon from '@mui/icons-material/Phone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';

import { Link } from 'react-router-dom';


export default function HomeButtons() {

  return (
    <Box sx={{

    }}>
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingTop: '10px',
        // border: '1px solid black',
        borderRadius: '25px',
        // backgroundColor: 'rgb(128, 0, 128)',
        backgroundColor: 'rgb(239, 202, 239, 0.38)',
        // backdropFilter: 'blur(10px)',
        // filter: 'blur(10px)',
      }}>

        <Box
          sx={{
            // padding: '10px',
            // backgroundColor: 'green',
          }}
        >
          <PhoneIcon
            fontSize={'large'}
            sx={{
              width: '100%',
              paddingRight: '5px',
              paddingLeft: '5px',
              paddingTop: '5px',
              paddingBottom: '5px',
              border: '1px solid green',
              backgroundColor: 'green',
              color: 'white',
              borderRadius: '5px',
            }}
          />

        </Box>

        <Box>
          <ChatBubbleOutlineIcon
            fontSize={'large'}
            sx={{
              width: '100%',
              paddingRight: '5px',
              paddingLeft: '5px',
              paddingTop: '5px',
              paddingBottom: '5px',
              border: '1px solid green',
              backgroundColor: 'green',
              color: 'white',
              borderRadius: '5px',
            }}
          />
        </Box>

        <Box>
          <WhatsAppIcon
            fontSize={'large'}
            sx={{
              width: '100%',
              paddingRight: '5px',
              paddingLeft: '5px',
              paddingTop: '5px',
              paddingBottom: '5px',
              border: '1px solid green',
              backgroundColor: 'green',
              color: 'white',
              borderRadius: '5px',
            }}
          />
        </Box>

        <Box>
          <MailOutlineIcon
            fontSize={'large'}
            sx={{
              width: '100%',
              paddingRight: '5px',
              paddingLeft: '5px',
              paddingTop: '5px',
              paddingBottom: '5px',
              border: '1px solid green',
              backgroundColor: 'green',
              color: 'white',
              borderRadius: '5px',
            }}
          />
        </Box>

      </Box >
    </Box>
  );

}